import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import axios from 'axios';
import './index.css';
import App from './App';
import ErrorBoundary from './shared/ErrorBoundary';
import { installGlobalErrorReporting, attachAxiosInterceptor } from './shared/errorReporting';
import { msalConfig } from './config/msal';

installGlobalErrorReporting();
attachAxiosInterceptor(axios);

const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

async function bootstrap() {
  await msalInstance.initialize();

  root.render(
    <ErrorBoundary>
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </React.StrictMode>
    </ErrorBoundary>,
  );
}

bootstrap().catch((err) => {
  // eslint-disable-next-line no-console
  console.error('MSAL initialization failed:', err);

  root.render(
    <React.StrictMode>
      <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', fontFamily: 'Arial, sans-serif' }}>
        <div style={{ textAlign: 'center', maxWidth: 460, padding: 16 }}>
          <h2 style={{ marginBottom: 8 }}>Initialization failed</h2>
          <p style={{ margin: 0, color: '#555' }}>Unable to initialize Microsoft authentication. Please refresh and try again.</p>
        </div>
      </div>
    </React.StrictMode>,
  );
});
